import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { UiDataTable } from '@/components/common/ui'
import { computed, reactive } from 'vue'
import { ERowTypes, ITableData } from '@/types/interfaces/table'
import DeleteAdviceButtonVue from './DeleteAdviceButton.vue'
import { AdviceInInvoiceDetails, useAdviceDocuments } from '@/composables/useAdviceDocuments'
import { useNotifications } from '@/composables/useNotifications'

type Props = {
    advices: AdviceInInvoiceDetails[]
}

export default /*#__PURE__*/_defineComponent({
  props: {
    advices: { type: Array, required: true }
  },
  setup(__props: any) {

const props = __props as {
    advices: AdviceInInvoiceDetails[]
}
const { selectedAdvices, removeAdviceFromStorage } = useAdviceDocuments()
const { pushSuccess } = useNotifications()



const tableData: ITableData = reactive({
    head: [],
    body: [],
})
tableData.head = [
    'Nr zlecenia',
    'data załadunku',
    'data wyładunku',
    'tonaż',
    'Kierowca',
    'Numery rejestracyjne',
    'Akcje',
]
tableData.body = computed(() =>
    props.advices.map(row => {
        return [
            row.axId,
            row.loadingDate,
            row.deliveryDate,
            row.quantity,
            row.driver,
            row.vehicleIdentificationNumber,
            {
                type: ERowTypes.COMPONENT,
                component: DeleteAdviceButtonVue,
                componentConfig: {
                    primary: true,
                    confirmationRequired: true,
                    disabled: lastItemInList.value,
                    showTooltip: lastItemInList.value,
                    tooltipMessage: 'Faktura musi zawierać co najmniej 1 zlecenie',
                    confirmationMessage: `Czy na pewno usunąć zlecenie ${row.axId}?`,
                    confirmationCallback: () => {
                        onAdviceRemove(row.axId).then(() => {
                            pushSuccess(`Zlecenie ${row.axId} zostało usunięte z listy`)
                        })
                    },
                },
            },
        ]
    }),
)
const lastItemInList = computed(() => {
    return selectedAdvices.value.length <= 1
})
const onAdviceRemove = (axId: string) => {
    const foundAdvice = props.advices.find(e => e.axId === axId)
    if (foundAdvice) {
        return removeAdviceFromStorage(foundAdvice.id)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UiDataTable), {
    data: _unref(tableData),
    "horizontal-on-mobile": "",
    "cell-class-on-mobile": "bg-primary bg-opacity-10"
  }, {
    "row-title": _withCtx(({index}) => [
      _createTextVNode(" # " + _toDisplayString(index), 1)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})